import script from "./MST45_031INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST45_031INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__